export default __webpack_public_path__ + "static/medianetwork-32ee72c55ba84766a35949dd7791d696.svg";